var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkOffBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2504 16.4508L17.7504 14.9008C18.4171 14.7174 18.9587 14.3631 19.3754 13.8378C19.7921 13.3124 20.0004 12.7001 20.0004 12.0008C20.0004 11.1674 19.7087 10.4591 19.1254 9.87578C18.5421 9.29245 17.8337 9.00078 17.0004 9.00078H13.0004V7.00078H17.0004C18.3837 7.00078 19.5631 7.48845 20.5384 8.46378C21.5137 9.43911 22.0011 10.6181 22.0004 12.0008C22.0004 12.9508 21.7547 13.8258 21.2634 14.6258C20.7721 15.4258 20.1011 16.0341 19.2504 16.4508ZM15.8504 13.0008L13.8504 11.0008H16.0004V13.0008H15.8504ZM19.8004 22.6008L1.40039 4.20078L2.80039 2.80078L21.2004 21.2008L19.8004 22.6008ZM11.0004 17.0008H7.00039C5.61706 17.0008 4.43806 16.5131 3.46339 15.5378C2.48872 14.5624 2.00106 13.3834 2.00039 12.0008C2.00039 10.8508 2.35039 9.82578 3.05039 8.92578C3.75039 8.02578 4.65039 7.43411 5.75039 7.15078L7.60039 9.00078H7.00039C6.16706 9.00078 5.45872 9.29245 4.87539 9.87578C4.29206 10.4591 4.00039 11.1674 4.00039 12.0008C4.00039 12.8341 4.29206 13.5424 4.87539 14.1258C5.45872 14.7091 6.16706 15.0008 7.00039 15.0008H11.0004V17.0008ZM8.00039 13.0008V11.0008H9.62539L11.6004 13.0008H8.00039Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkOffBlack);
export default __webpack_public_path__ + "static/media/icon_link_off_black.148427e05ccfe47ec91bc5d47e206e82.svg";
export { ForwardRef as ReactComponent };